module.exports = __webpack_public_path__ + "img/049-cooking.857dd20e.svg";